import Flickity from 'flickity';
import FlickityImages from 'flickity-imagesloaded';
import AOS from 'aos';
import { moreInformation, footerClose } from './components/footer';
import anime from 'animejs'
import axios from 'axios';


const carousel = document.getElementById("main-carousel");
const cell = document.getElementsByClassName("carousel-cell");
let carouselArrows = document.querySelectorAll(".carousel-arrows");

AOS.init();
moreInformation.init();
getCartCount();

[...carouselArrows].forEach(arrow => {
    arrow.addEventListener("mousemove", function(event) {
        setCursor(event);
    });
})


let addToCart = document.querySelectorAll('.add-to-cart');
[...addToCart].forEach(item => {
    item.addEventListener("click", function(e) {
        let id = e.target.getAttribute("data-id");
        // alert(id);
        // axios.post('https://ciaopress.com/wp/wp-json/cocart/v1/add-item', {
        //         product_id: id,
        //         quantity: 1
        //     })
        //     .then(function(response) {
        //         console.log(response);
        //     })
        //     .catch(function(error) {
        //         console.log(error);
        //     });

        axios
            .get("https://ciaopress.com/wp/wp-json/ciao/v1/add_to_cart", {
                params: { product_id: id, quantity: 1}
            })
            .then(function(response) {
                getCartCount();
                //make some fun here
            })
    })
})


new Marquee('marquee', {
    direction: 'rtl',
    speed: 1,
});

let numberOfBooks = document.querySelectorAll(".book-content").length;




showInfo(1);
window.onscroll = function(ev) {
    for (let i = 0; i < numberOfBooks; i++) {
        let before = document.querySelector("#book-content-" + (i + 1));
        let heightOfDiv = before.clientHeight;


        if (window.scrollY >= heightOfDiv * i && window.scrollY <= heightOfDiv * (i + 1) - 500) {
            // console.log(window.scrollY + ">=" + heightOfDiv * i + " && " + window.scrollY + " <= " + heightOfDiv * (i + 1))
            hideAll();
            showInfo(i + 1);
        }


        // if (window.scrollY >= heightOfDiv * i && window.scrollY <= heightOfDiv * i + 1) {
        //     console.log(heightOfDiv * i);
        //     hideAll(1);
        //     showInfo(i);
        // }

    }

};


function getCartCount() {
    let count = document.querySelector("#count");
    axios.get("https://ciaopress.com/wp/wp-json/ciao/v1/get_cart_count", {})
        .then(function(response) {
            count.textContent = response.data;
        })

}

function hideAll() {
    let info = document.querySelectorAll('.book-item');
    [...info].forEach(item => {
        item.style.display = "none";
    });
}

function hideInfo(num) {
    let info = document.querySelectorAll('.book_' + num);
    [...info].forEach(item => {
        item.style.display = "none";
    });
}

function showInfo(num) {
    let info = document.querySelectorAll('.book_' + num);
    [...info].forEach(item => {
        item.style.display = "block";
    });
}

const body = document.querySelector("body");
// var galleryElems = document.querySelectorAll('.carousel');
// for (var i = 0, len = galleryElems.length; i < len; i++) {
//     var galleryElem = galleryElems[i];
//     var flky = new Flickity(galleryElem, {
//         arrowShape: "M90.6,48.8V52H15.5c3.1,2.8,11.2,11.2,18.2,18.7C38,75,42.5,79.8,47.4,85H42.7C35.1,77,19.1,59.3,10,50.5c9-9,25-26.5,32.7-34.4h4.7L33.7,30.2c-7.1,7.4-15.3,15.7-18.2,18.6Z",
//         imagesLoaded: true,
//         prevNextButtons: false,
//         pageDots: false,
//         lazyLoad: true,
//         wrapAround: true,
//         cellAlign: "center"
//     });
// }

var elems = document.querySelectorAll('.carousel');
elems.forEach(function(elem, index) {
    var flkty = new Flickity(elem, {
        arrowShape: "M90.6,48.8V52H15.5c3.1,2.8,11.2,11.2,18.2,18.7C38,75,42.5,79.8,47.4,85H42.7C35.1,77,19.1,59.3,10,50.5c9-9,25-26.5,32.7-34.4h4.7L33.7,30.2c-7.1,7.4-15.3,15.7-18.2,18.6Z",
        imagesLoaded: true,
        prevNextButtons: false,
        pageDots: false,
        lazyLoad: true,
        wrapAround: true,
        draggable: false,
        cellAlign: "center"
    });

    elem.addEventListener("click", (e) => {
        flkty.next();
    });
});




function setCursor(e) {
    var x = e.clientX;
    var y = e.clientY;
    var coor = "Coordinates: (" + carousel.offsetWidth / 2 + " " + x + "," + y + ")";


    if (x < (carousel.offsetWidth / 2)) {
        e.target.classList.remove("next-cursor");
        e.target.classList.add("prev-cursor");

    } else {
        e.target.classList.remove("prev-cursor");
        e.target.classList.add("next-cursor");
    }
}

// Get the video
var video = document.getElementById("myVideo");
video.pause();

const info = document.getElementById('info');

const infoContent = document.getElementById('info-content');
const infoVideo = document.getElementById('info-video');
infoContent.init = () => {
    infoContent.style.top = -(infoContent.offsetHeight) + "px";
};


infoContent.init();
info.onclick = () => {
    if (!infoContent.classList.contains("active")) {
        anime({
            targets: infoContent,
            top: 0,
            duration: 1400,
            loop: false,
            easing: 'easeInOutQuart',
            complete: function() {
                infoVideo.classList.add("active");
                video.play();
                anime({
                    targets: info,
                    top: (infoContent.offsetHeight + 10) + "px",
                    duration: 1400,
                    loop: false,
                    easing: 'easeInOutQuart'
                });
                info.textContent = "CLOSE";
            }
        });
        infoContent.classList.add("active");
    } else {
        anime({
            targets: infoContent,
            top: -(infoContent.offsetHeight),
            duration: 1400,
            loop: false,
            easing: 'easeInOutQuart',
            complete: function() {
                infoVideo.classList.remove("active");
                video.pause();
                anime({
                    targets: info,
                    top: 20 + "px",
                    duration: 1400,
                    loop: false,
                    easing: 'easeInOutQuart'
                });
                info.textContent = "INFO";
            }
        });
        infoContent.classList.remove("active");
    }
};

const landing = document.getElementById("landing-content");
landing.addEventListener("click", function(event) {
    if (!landing.classList.contains("hide")) {
        landing.classList.add("hide")
    }
});

var resizeTimer;

window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        infoContent.style.top = -(infoContent.offsetHeight) + "px";
        info.style.top = 20 + "px";
        infoVideo.classList.remove("active");
        video.pause();
    }, 250);
});


// var locations = document.getElementsByName('location');
// var value_price = document.getElementById('value_price');

// var price = 37;
// var amount = 42;
// var ship_switzerland = 5;

// // var price = 1;
// // var amount = 1;
// // var ship_switzerland = 0;


// var ship_europe = 10;
// var ship_international = 18;
// var description = "OUTBURST - Ciao Press"
// var currency = 'EUR';
// var ship;
// value_price.textContent = "ORDER " + price + " + " + "" + ship_switzerland;
// for (var i = 0, length = locations.length; i < length; i++) {
//     locations[i].addEventListener('click', function(e) {

//         switch (this.value) {
//             case "SWITZERLAND":
//                 amount = price + ship_switzerland;
//                 currency = 'EUR';
//                 ship = ship_switzerland;
//                 break;
//             case "EUROPE":
//                 amount = price + ship_europe;
//                 currency = 'EUR'
//                 ship = ship_europe;
//                 break;
//             case "INTERNATIONAL":
//                 amount = price + ship_international;
//                 currency = 'EUR';
//                 ship = ship_international;
//                 break;
//         }
//         // value_price.textContent = amount;

//         value_price.textContent = "ORDER " + price + " + " + "" + ship;

//     });
// }



// document.getElementById('customButton').addEventListener('click', function(e) {
//     var location = "SWITZERLAND";
//     var currency = 'EUR';
//     for (var i = 0, length = locations.length; i < length; i++) {
//         if (locations[i].checked) {
//             location = locations[i].checked;
//             break;
//         }
//     }
//     switch (location) {
//         case "SWITZERLAND":
//             amount = price + ship_switzerland;
//             currency = 'EUR';
//             break;
//         case "EUROPE":
//             amount = price + ship_europe;
//             currency = 'EUR';
//             break;
//         case "INTERNATIONAL":
//             amount = price + ship_international;
//             currency = 'EUR';
//             break;
//     }

//     if (amount < 1000) {
//         amount = amount * 100;
//     }



//     var handler = StripeCheckout.configure({
//         // key: 'pk_test_c4oEM9Y7byuFkVsmhW826V8v',
//         key: 'pk_live_1VztoIUFOT3gYdyedoaycPrs',
//         image: 'https://ciaopress.com/src/img/stripe-image.png',
//         locale: 'EN',
//         token: function(token) {
//             $.ajax({
//                 type: "POST",
//                 url: "charge.php",
//                 data: { stripeToken: token.id, stripeEmail: token.email, amount: amount }
//             })
//         }
//     });

//     handler.open({
//         name: 'CiaoPress',
//         description: 'OUTBURST - Ciao Press',
//         currency: currency,
//         billingAddress: true,
//         amount: amount
//     });
//     e.preventDefault();
// });

// window.addEventListener('popstate', function() {
//     handler.close();
// });

// import Loader from './services/loader';
// import LazyLoad from './services/LazyLoad';
// import Utils from './services/Utils';
// import Home from './components/Home';
// import Nav from './components/Nav';

// let load = true;
// const App = {
//     init: async () => {
//         if (load) {
//             await App.sizeSet();
//             await Loader.init();
//             await Home.init();
//             await Nav.init();
//             await LazyLoad.init();
//         }
//     },
//     sizeSet: () => {
//         App.width = (window.innerWidth || document.documentElement.clientWidth);
//         App.height = (window.innerHeight || document.documentElement.clientHeight);
//         if (App.width <= 768)
//             App.isMobile = true;
//         if (App.isMobile) {
//             if (App.width > 768) {
//                 App.isMobile = false;
//             }
//         }
//     }
// };

// export default App;

// document.addEventListener("DOMContentLoaded", () => {
//     App.init();
//     window.addEventListener('resize', App.sizeSet);
// });